import { FormattedMessage } from 'react-intl';

import { useGraphSize } from '../chart-layout/hooks/useGraphSize.js';

/**
 * No data component used for displaying the "No data available" message inside an <svg> element.
 */
export function NoData() {
  const { width, height } = useGraphSize();

  return (
    <svg width={width} height={height}>
      <text
        data-testid="no-data-text"
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="currentColor"
      >
        <FormattedMessage
          id="VkfutNWZVq0loZNC"
          defaultMessage="No data available."
          description="Message to display when no data is available"
        />
      </text>
    </svg>
  );
}
